import React from 'react'
import { useTranslation } from 'react-i18next'

interface RedirectLinksCountCellProps {
  affiliate_id: string
  redirects_count: number
  expandedRowKeys?: string[]
  onToggleExpand?: (isShow: boolean, key: string) => void
}

export const RedirectLinksCountCell = ({
  affiliate_id,
  redirects_count,
  expandedRowKeys,
  onToggleExpand,
}: RedirectLinksCountCellProps) => {
  const { t } = useTranslation()

  return (
    <div className='flex items-center'>
      {redirects_count}

      {expandedRowKeys?.includes(affiliate_id) ? (
        <span
          className={
            'ml-4 cursor-pointer border-b border-dotted text-[13px] leading-[13px] text-focus'
          }
          onClick={() => {
            onToggleExpand && onToggleExpand(false, affiliate_id)
          }}
        >
          {t('buttons.close')}
        </span>
      ) : (
        <span
          className={
            'ml-4 cursor-pointer border-b border-dotted text-[13px] leading-[13px] text-focus'
          }
          onClick={() => {
            onToggleExpand && onToggleExpand(true, affiliate_id)
          }}
        >
          {t('buttons.show')}
        </span>
      )}
    </div>
  )
}
